export default __webpack_public_path__ + "static/media/logo.47458e55.png";